import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  AppLanguage,
  LanguageService,
} from 'src/app/services/language.service';
import { AppDropdownModel } from '../UI/dropdown/dropdown.types';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, take } from 'rxjs';
import { StorageKeys, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  control: FormControl<AppLanguage | null> =
    new FormControl<AppLanguage | null>(null);
  @Output() languageChanged = new EventEmitter<AppLanguage>();

  public languageDropdownModel: AppDropdownModel = { options: [] };

  constructor(
    private readonly languageService: LanguageService,
    private readonly translationService: TranslateService,
    private readonly storageService: StorageService
  ) {}

  ngOnInit() {
    this.initLanguageSelector();
  }

  private initLanguageSelector(): void {
    this.languageService.currentLang.pipe(take(1)).subscribe((currentLang) => {
      let langToSet: AppLanguage = currentLang;
      this.updateLanguageDropdownModel();
      this.storageService
        .get<AppLanguage>(StorageKeys.LANGUAGE)
        .subscribe((storedLangSetting) => {
          if (storedLangSetting) {
            langToSet = storedLangSetting;
          }
          this.control.setValue(langToSet);
        });
    });

    this.control.valueChanges.pipe(distinctUntilChanged()).subscribe((lang) => {
      this.languageService.setLanguage(lang!);
      this.updateLanguageDropdownModel();
      this.languageChanged.emit(lang!);
    });
  }

  private updateLanguageDropdownModel(): void {
    this.languageDropdownModel.options = this.languageService
      .getSupportedLanguages()
      .map((lang) => {
        return {
          value: lang,
          label: this.translationService.instant('@common.languages.' + lang),
        };
      });
  }
}
